import apiClient from '../apiClient';
import { GET_CUSTOM_ENUM_BY_CATAGORIES } from '../apiUrl';

const getCustomEnumByCatagoriesTotalBranchApi = () => {
  return apiClient.get(GET_CUSTOM_ENUM_BY_CATAGORIES('TOTAL_BRANCH'));
};

export default getCustomEnumByCatagoriesTotalBranchApi;
